import React, { useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import  packageJson  from '../../../package.json'
import { CartState } from '../../Context/Context'

const SideBar = () => {
  const navigation = useNavigate()
  const [sidebarTranslate, setSideBar] = useState({})
  const user = JSON.parse(localStorage.getItem('userData'))
  const { t } = useTranslation()
  const {
    Overview,
    Open_Tasks,
    HFTChangeRequestStatus,
    POList,
    UrgentInquiry,
    MyReport,
    BulkUpload,
    Logout,
    Help,
    Messages,
    RecreateConfirm
  } = t('sidebar')
  const {    
    unseenList
  } = CartState()

  // setTimeout(() => {
  //

  // }, 50);
  useLayoutEffect(() => {
    setSideBar(t('sidebar'))
  }, [])
  return (
    <div className='min-w-[220px] flex flex-col gap-5 justify-between min-sidebar-screen items-start h-full sticky top-0 bg-blue-100 overflow-y-auto'>
      <div className='w-full flex flex-col gap-3 h-full'>
        {/* <div className="px-4 py-2 bg-white">
          <img
            src="https://images.harborfreight.com/media/logos/harborfreight-logo.svg"
            width="100%"
            height="100%"
            alt="harbor_freight_logo"
            className="object-contain w-[165px] h-[53px]"
          />
        </div> */}
        <div className='w-full flex flex-col justify-start h-full relative items-start gap-4 border-[#E6EDFF] border-r py-5' style={{ fontWeight: 500 }}>
          <div
            key={'buyer'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname === '/buyer' && 'bg-[#0059A8]'
              }`}
            onClick={() => {
              navigation('/buyer')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white  ${window?.location?.pathname === '/buyer' && 'text-white'
                }`}
            >
              {Overview}
            </p>
          </div>
          {/* <div
            key={'buyer/open_tasks'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${
              window?.location?.pathname.includes('buyer/open_tasks') &&
              'bg-[#0059A8]'
            } ${user?.userGroupName === "OVERSEAS_ROLE"  && 'hidden'}
            `}
            onClick={() => {
              navigation('/buyer/open_tasks')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${
                window?.location?.pathname.includes('buyer/open_tasks') &&
                'text-white'
              }`}
            >
              {Open_Tasks}
            </p>
          </div> */}
          <div
            key={'buyer/hft_buyer_change_requests'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname.includes(
              'buyer/hft_buyer_change_requests'
            ) && 'bg-[#0059A8]'
              } ${user?.userGroupName === "OVERSEAS_ROLE" && 'hidden'}`}
            onClick={() => {
              navigation('/buyer/hft_buyer_change_requests')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${window?.location?.pathname.includes(
                'buyer/hft_buyer_change_requests'
              ) && 'text-white'
                }`}
            >
              {HFTChangeRequestStatus}
            </p>
          </div>
          <div
            key={'buyer/po_list'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname.includes('buyer/po_list') &&
              'bg-[#0059A8]'
              } `}
            onClick={() => {
              navigation('/buyer/po_list')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${window?.location?.pathname.includes('buyer/po_list') &&
                'text-white'
                }`}
            >
              {POList}
            </p>
          </div>
        
          {
            user?.roleType === 'BUYER' &&
            <div
              key={'buyer/messages'}
              className={`w-full justify-between flex px-2 text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname.includes('buyer/messages') &&
                'bg-[#0059A8]'
                }`}
              onClick={() => {
                navigation('/buyer/messages')
              }}
            >
              <p
                className={`text-black p-2  group-hover:text-white ${window?.location?.pathname.includes('buyer/messages') &&
                  'text-white'
                  }`}
              >
                {Messages}
              </p>
              <div className='bg-[#0059A8] text-white items-center justify-center p-1 h-6 text-center rounded-lg'>
              {unseenList?.messageCounts?.length}
            </div>
            </div>
          }
          <div
            key={'buyer/urgent_orders'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname.includes('buyer/urgent_orders') &&
              'bg-[#0059A8]'
              } ${user?.userGroupName === "OVERSEAS_ROLE" && 'hidden'}`}
            onClick={() => {
              navigation('/buyer/urgent_orders')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${window?.location?.pathname.includes('buyer/urgent_orders') &&
                'text-white'
                }`}
            >
              {UrgentInquiry}
            </p>
          </div>
          <div
            key={'buyer/my_report'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname.includes('buyer/my_report') &&
              'bg-[#0059A8]'
              } ${user?.userGroupName === "OVERSEAS_ROLE" && 'hidden'}`}
            onClick={() => {
              navigation('/buyer/my_report')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${window?.location?.pathname.includes('buyer/my_report') &&
                'text-white'
                }`}
            >
              {MyReport}
            </p>
          </div>
          <div
            key={'buyer/bulk-upload'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname.includes('buyer/bulk-upload') &&
              'bg-[#0059A8]'
              } ${user?.userGroupName === "OVERSEAS_ROLE" && 'hidden'}`}
            onClick={() => {
              navigation('/buyer/bulk-upload')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${window?.location?.pathname.includes('buyer/bulk-upload') &&
                'text-white'
                }`}
            >
              {BulkUpload}
            </p>
          </div>

          <div
            key={'buyer/po-revision-upload'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#5A189A] group ${window?.location?.pathname.includes('buyer/po-revision-upload') &&
              'bg-[#5A189A]'
              } ${user?.userGroupName === "OVERSEAS_ROLE" && 'hidden'}`}
            onClick={() => {
              navigation('/buyer/po-revision-upload')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${window?.location?.pathname.includes('buyer/po-revision-upload') &&
                'text-white'
                }`}
            >
              {'PO Revision Upload'}
            </p>
          </div>
        
          <div
            key={'buyer/confirm-regeneration'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname.includes('buyer/confirm-regeneration') &&
              'bg-[#0059A8]'
              } ${user?.userGroupName === "OVERSEAS_ROLE" && 'hidden'}`}
            onClick={() => {
              navigation('/buyer/confirm-regeneration')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${window?.location?.pathname.includes('buyer/confirm-regeneration') &&
                'text-white'
                }`}
            >
              {RecreateConfirm}
            </p>
          </div>
        
          <div
            key={'training-videos'}
            className={`w-full justify-between flex text-xs items-center cursor-pointer hover:bg-[#0059A8] group ${window?.location?.pathname.includes('/training-videos') &&
              'bg-[#0059A8]'
              }`}
            onClick={() => {
              navigation('/training-videos')
            }}
          >
            <p
              className={`text-black p-2 pl-4 group-hover:text-white ${window?.location?.pathname.includes('training-videos') &&
                'text-white'
                }`}
            >
              {Help}
            </p>
          </div>
        </div>
      </div>
      <div className='w-full px-6 py-2 border-t border-blue-200 text-[10px] text-gray-500 font-medium self-end'>
        v {packageJson?.version}
      </div>
    </div>
  )
}

export default SideBar
